import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useEffect as $cKEhs$useEffect } from "react";
import { useToggle as $cKEhs$useToggle } from "@react-aria/toggle";
import { filterDOMProps as $cKEhs$filterDOMProps, mergeProps as $cKEhs$mergeProps } from "@react-aria/utils";
import { useLabel as $cKEhs$useLabel } from "@react-aria/label";
import { useToggleState as $cKEhs$useToggleState } from "@react-stately/toggle";
function $406796ff087fe49b$export$e375f10ce42261c5(props, state, inputRef) {
  var _$cKEhs$useToggle = $cKEhs$useToggle(props, state, inputRef),
    inputProps = _$cKEhs$useToggle.inputProps;
  var isSelected = state.isSelected;
  var isIndeterminate = props.isIndeterminate;
  $cKEhs$useEffect(function () {
    // indeterminate is a property, but it can only be set via javascript
    // https://css-tricks.com/indeterminate-checkboxes/
    if (inputRef.current) inputRef.current.indeterminate = isIndeterminate;
  });
  return {
    inputProps: _objectSpread(_objectSpread({}, inputProps), {}, {
      checked: isSelected,
      'aria-checked': isIndeterminate ? 'mixed' : isSelected
    })
  };
}
var $1ae600c947479353$export$31440636951aa68c = new WeakMap();
function $1e9fce0cfacc738b$export$49ff6f28c54f1cbe(props, state) {
  var isDisabled = props.isDisabled,
    name = props.name;
  var _$cKEhs$useLabel = $cKEhs$useLabel(_objectSpread(_objectSpread({}, props), {}, {
      // Checkbox group is not an HTML input element so it
      // shouldn't be labeled by a <label> element.
      labelElementType: 'span'
    })),
    labelProps = _$cKEhs$useLabel.labelProps,
    fieldProps = _$cKEhs$useLabel.fieldProps;
  var domProps = $cKEhs$filterDOMProps(props, {
    labelable: true
  });
  // Pass name prop from group to all items by attaching to the state.
  $1ae600c947479353$export$31440636951aa68c.set(state, name);
  return {
    groupProps: $cKEhs$mergeProps(domProps, _objectSpread({
      role: 'group',
      'aria-disabled': isDisabled || undefined
    }, fieldProps)),
    labelProps: labelProps
  };
}
function $fba3e38d5ca8983f$export$353b32fc6898d37d(props, state, inputRef) {
  var toggleState = $cKEhs$useToggleState({
    isReadOnly: props.isReadOnly || state.isReadOnly,
    isSelected: state.isSelected(props.value),
    onChange: function onChange(isSelected) {
      if (isSelected) state.addValue(props.value);else state.removeValue(props.value);
      if (props.onChange) props.onChange(isSelected);
    }
  });
  var _$406796ff087fe49b$ex = $406796ff087fe49b$export$e375f10ce42261c5(_objectSpread(_objectSpread({}, props), {}, {
      isReadOnly: props.isReadOnly || state.isReadOnly,
      isDisabled: props.isDisabled || state.isDisabled,
      name: props.name || $1ae600c947479353$export$31440636951aa68c.get(state)
    }), toggleState, inputRef),
    inputProps = _$406796ff087fe49b$ex.inputProps;
  return {
    inputProps: inputProps
  };
}
export { $406796ff087fe49b$export$e375f10ce42261c5 as useCheckbox, $1e9fce0cfacc738b$export$49ff6f28c54f1cbe as useCheckboxGroup, $fba3e38d5ca8983f$export$353b32fc6898d37d as useCheckboxGroupItem };